<div class="teamWrapper">
    <div class="maxContainerWidth">
        <div class="title text-center">
            <h1 class="text-white">
                Meet our team of creative experts
            </h1>
            <p>
                PostEx. transforms recurring revenue into up-front capital for growth without restrictive debt or dilution.
            </p>   
        
        </div>
        <div class="teamWrap">
            <ng-container *ngFor="let person of teamData">
                <div class="person">
                    <div class="profile">
                        <img src="assets/images/team/{{person.imagSrc}}" alt="">
                    </div>
                    <div class="detail">
                        <h3>
                            {{person.name}}
                        </h3>
                        <p>
                            {{person.designation}}
                        </p>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>